<template>
  <div class="mx-auto flex w-full max-w-container flex-col justify-center gap-14 pt-11">
    <slot> </slot>
  </div>
</template>
